import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { resolveResponsiveRangePropsOptional } from '../../library/props/responsiveRangeProps';
import { Box } from '../Box/Box';
import { FlexViewContext } from './FlexView';
export const Item = ({ children, hide, ...allBoxProps }) => {
    const { alignItems, justifyContent, componentItem } = useContext(FlexViewContext);
    const display = alignItems || justifyContent ? 'flex' : 'block';
    return (_jsx(Box, { minWidth: 0, display: resolveResponsiveRangePropsOptional(hide, 'none', display) ?? display, justifyContent: justifyContent, alignItems: alignItems, component: componentItem, ...allBoxProps, children: children }));
};
